import { PublicClientApplication } from "@azure/msal-browser";

const getMsalSettings = () => {
  const config = window.config?.sso || {};
  const clientId = config.clientId || "";
  const rawAuthority = (config.authority || "").trim();
  const authority = rawAuthority ? (/^https?:\/\//i.test(rawAuthority) ? rawAuthority : `https://login.microsoftonline.com/${rawAuthority}`) : "";
  const redirectUri = config.redirectUri || window.location.origin;
  const scopes = Array.isArray(config.scopes) && config.scopes.length ? config.scopes : ["User.Read"];
  const isConfigured = Boolean(clientId && authority);

  return { clientId, authority, redirectUri, scopes, isConfigured };
};

const msalSettings = getMsalSettings();

let msalInstance = null;

if (msalSettings.isConfigured) {
  msalInstance = new PublicClientApplication({
    auth: {
      clientId: msalSettings.clientId,
      authority: msalSettings.authority,
      redirectUri: msalSettings.redirectUri
    },
    cache: {
      cacheLocation: "sessionStorage"
    }
  });
}

export { msalInstance, msalSettings };
